module.exports = __webpack_public_path__ + "static/Header2x-99be2da528d60eb33bfceecef53473ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/marvel-vs-zeplin/Header2x.jpg
// module id = 2667
// module chunks = 21098653631116